import Vue from 'vue'
import './scss/style.scss'
import App from './App.vue'
import i18n from './localization/i18n'
import router from './router/index'
import store from './store'
import './echo'
import { ValidationProvider, ValidationObserver, configure, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { BootstrapVue } from 'bootstrap-vue'
import Toasted from 'vue-toasted'
import Multiselect from 'vue-multiselect'
import CKEditor from 'ckeditor4-vue'
import InputTag from 'vue-input-tag'
import ClickOutside from 'vue-click-outside'
import VJsoneditor from 'v-jsoneditor/src/index'
import VueChatScroll from 'vue-chat-scroll'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAP_KEY,
    libraries: 'places'
  }
})

Vue.use(VueChatScroll)
Vue.use(VJsoneditor)
Vue.directive('click-outside', ClickOutside)

Vue.use(require('vue-moment'))
Vue.use(CKEditor)

Vue.component('input-tag', InputTag)

Vue.component('multiselect', Multiselect)

Vue.use(BootstrapVue)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
configure({
  classes: {
    invalid: 'is-invalid'
  }
})
// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
extend('positive', value => {
  if (value.slice(0, 24) >= 'https://www.youtube.com/') {
    return true
  }
})

Vue.use(Toasted, {
  type: ['success', 'error']
})

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  render: h => h(App),
  router: router
}).$mount('#app')
